import { createElement } from 'react';
import { DatePicker as OriginalDatePicker } from 'antd';
const DatePicker = function DatePicker({ ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement(OriginalDatePicker, { ..._otherProps }));
};
export default DatePicker;
